module.exports = __webpack_public_path__ + "236ed9142a7d286e2f69fcbf6fc3fa55.pdf";